function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "loginDiamondTop_svg__a",
  d: "M54.67 0l52.82 54.644-54.644 52.82L.026 52.82zM129.142 52.344l19.46 20.132-20.132 19.46-19.46-20.132z"
});

function SvgLoginDiamondTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.592 107.464"
  }, props), _ref, _ref2);
}

export default SvgLoginDiamondTop;